import axios from "@/axios.js"
import { erpApi } from "@/axios.js" 

export default {
  fetchDataListItems({ commit }) {
    return axios.get("/api/PropertyOwner/GetAll").then(res => {
      commit('SET_PROPERTY_OWNERS', res.data.Data);
    });
  },
  GetItemByID({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/PropertyOwner/GetById/${itemid}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
      .then((response) => {
        commit('GET_ITEM_BY_ID', response.data.Data); 
        resolve(response);
      })
      .catch((error) => { reject(error) });
    });
  },
  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("/api/PropertyOwner/Update", item, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
      .then(response => {
        commit('UPDATE_PROPERTY_OWNER', item);
        resolve(response);
      })
      .catch(error => { reject(error); });
    });
  },
addItem({ commit }, item) {
  return new Promise((resolve, reject) => {

    axios.post("/api/PropertyOwner/Add", item, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {

      const resData = response.data.Data; 

      if (resData) {
       
        commit('ADD_ITEM', Object.assign(item, { ID: resData.Id }));
        

        const erpPayload = {
          OwnerCode: resData.OwnerCode || resData.OwnerCode, 
          OwnerNameAr: resData.OwnerNameAr || resData.FullNameAr,
          OwnerNameEn: resData.OwnerNameEn || resData.FullNameEn
        };

     
        erpApi.post("api/erp/integration/create-owner-account", erpPayload)
          .then((erpResponse) => {
            console.log("تمت المزامنة مع الـ ERP بنجاح (حساب المالك):", erpResponse.data);
            resolve(response);
          })
          .catch((erpError) => {
            console.error("فشلت المزامنة مع الـ ERP ولكن تم الحفظ للمالك في رقمنة:", erpError);
            resolve(response); 
          });
      } else {
        console.error("Failed to add owner. Response data:", response.data);
        resolve(response);
      }
    })
    .catch((error) => { 
      reject(error); 
    });
  });
},
  toggleOwnerStatus({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/PropertyOwner/ToggleStatus/${id}`)
        .then((response) => {
          if (response.data.Success || response.data.isSuccess) {
            commit('TOGGLE_OWNER_ACTIVE_STATUS', id);
            resolve(response);
          } else {
            reject(response.data.Message);
          }
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchFilteredOwners({ commit }, filters) {
    return axios.post("/api/PropertyOwner/Search", filters) 
      .then((response) => {
        commit("SET_PROPERTY_OWNERS", response.data.Data);
      })
      .catch((error) => { console.error(error); });
  },
  removeItem({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/PropertyOwner/Delete/${id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
      .then((response) => {
        commit('REMOVE_ITEM', id)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
fetchOwnerFinancialStatement(context, ownerId) {
  return axios
    .get(
      "/api/PropertyOwner/GetOwnerFinancialStatement/" + ownerId
    )
    .then(function (response) {
      return response.data;
    });
}
}